import type { RecipientGroupFormValuesType } from '@common';
import type { UpdateRecipientGroupRequestType } from 'src/api/generated/touring/types';

// The API replaces both lists, so always send them in full.
export const mapFormValuesToUpdateRecipientGroupRequest = ({
  label,
  recipients,
}: RecipientGroupFormValuesType): UpdateRecipientGroupRequestType => ({
  label: label.trim(),
  personRecipients: recipients.flatMap((r) =>
    r.kind === 'PERSON'
      ? [{ recipientId: r.personId, emailField: r.emailField }]
      : []
  ),
  customRecipients: recipients.flatMap((r) =>
    r.kind === 'CUSTOM'
      ? [{ name: r.name, email: r.email, emailField: r.emailField }]
      : []
  ),
});
